// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 182 ? "6de13d4a" : chunkId) + "." + {"182":"beac281e71e2b3322b8a","221":"65cef2108334223b7599"}[chunkId] + ".js";
};